import "./globals.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomeLayout from "src/components/Layout/HomeLayout";
import Confirm from "src/routes/confirm";
import Home from "src/routes/home";
import Waitlist from "src/routes/waitlist";
import About from "src/routes/about";
import Privacy from "src/routes/privacy";

const root = document.getElementById("root");
if (root) {
  ReactDOM.createRoot(root).render(
    <BrowserRouter>
      <Routes>
        <Route element={<HomeLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/waitlist-confirmed" element={<Confirm />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
        </Route>
        <Route
          path="*"
          element={
            <div className="h-full flex items-center justify-center">
              <h1 className="text-[5rem] md:text-[15rem]">404</h1>
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
} else {
  console.error("Root element not found");
}
